import React from 'react';
import StaticKeyMetricCard from 'src/components/BeaconV2Components/KeyMetricCards/StaticKeyMetricCard';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { formatMetric } from 'src/utils/app';
import { useConversionV2ChartData } from 'src/components/AtlasV2Components/AtlasConversionV2PageComponents/AtlasV2ConversionV2SplineChart';

interface ConversionCardProps {
  variant: 'large' | 'small' | 'medium';
  fieldName: string;
  title: string;
  onClick?: () => void;
}

const ConversionV2Card = ({ fieldName, variant, title, onClick }: ConversionCardProps) => {
  const { primarySeries, secondarySeries, loading, primaryDerivedMetricAverage, primaryDerivedMetricPercentChange } =
    useConversionV2ChartData();
  const mainMetric = formatMetric(primaryDerivedMetricAverage, METRICTYPE.PERCENT, {
    showFullValue: true,
    decimalPlaces: 2
  });

  return (
    <StaticKeyMetricCard
      variant={variant}
      fieldName={fieldName}
      metricTypeToDisplay={METRICTYPE.PERCENT}
      title={title}
      onClick={onClick}
      isLoading={loading}
      primaryData={primarySeries}
      secondaryData={secondarySeries}
      formattedPrimaryTotal={mainMetric}
      percentChange={primaryDerivedMetricPercentChange}
      formattedPercentChange={formatMetric(Math.abs(primaryDerivedMetricPercentChange), METRICTYPE.PERCENT, {
        showFullValue: true,
        decimalPlaces: 2
      })}
    />
  );
};

export default ConversionV2Card;
